import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL, PROFILE_PICTURE_URL } from "../../utils/Contants";

const Profile = () => {
  const userData = JSON.parse(localStorage.getItem("user"));
  const username = userData?.client_name ||userData?.staff_name || "User";
  const profile_image = userData.profile_picture;
  const is_client_admin = userData.is_client_admin;
  const initials = username
    .split(" ")
    .map((name) => name[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <Link to="/user-profile" className="text-decoration-none text-dark">
      <div className="d-flex align-items-center gap-2">
        <div
          className="rounded-circle bg-primary-600 text-white d-flex align-items-center justify-content-center"
          style={{ width: 40, height: 40 }}
        >
          {profile_image ? (
            <img
              src={
                profile_image.startsWith("http")
                  ? profile_image
                  : `${PROFILE_PICTURE_URL}/${profile_image}`
              }
              alt="profile"
              className="rounded-circle"
              style={{ width: 40, height: 40, objectFit: "cover" }}
            />
          ) : (
            <span className="fw-semibold">{initials}</span>
          )}
        </div>
        <span className="fw-medium text-primary-light">{username}</span>
      </div>
    </Link>
  );
};

export default Profile;
